import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { SDLSUrl } from "../../../../config";
import Form from "./form";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import Joyride from "react-joyride";
import { executeAnyMutation } from "../../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const base_url = SDLSUrl.uri;

const policyTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "Configure automated notification, warning, and remote lock policies triggered by repayment schedules.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to configure a new Policy rule.",
    placement: "right",
  },
];

const DeviceLockPoliciesTable = () => {
  const [runTour, setRunTour] = useState(false);

  const handleToggleActive = async (row, refetch) => {
    const isCurrentlyActive = !!row?.IsActive;
    const action = isCurrentlyActive ? "Deactivate" : "Activate";
    const confirm = await Swal.fire({
      title: `${action} Policy?`,
      text: `Are you sure you want to ${action.toLowerCase()} policy "${row.Title || row.PolicyType}"?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
    });
    if (!confirm.isConfirmed) return;

    const response = await executeAnyMutation(
      "updateDeviceLockPolicy",
      {
        policy: {
          id: row.Id,
          clientId: row.ClientId,
          productId: row.ProductId,
          policyType: row.PolicyType,
          triggerDays: row.TriggerDays,
          title: row.Title,
          contentTemplate: row.ContentTemplate,
          showType: row.ShowType,
          contactNumber: row.ContactNumber,
          emailAddress: row.EmailAddress,
          forbidIncomingCall: row.ForbidIncomingCall,
          allowIncomingList: row.AllowIncomingList,
          supportUserRefresh: row.SupportUserRefresh,
          allowApp: row.AllowApp,
          allowAppList: row.AllowAppList,
          isActive: !isCurrentlyActive,
        }
      },
      "FEOutput",
      false,
      base_url
    );

    if (response?.results) {
      await Swal.fire("Done!", `Policy has been ${!isCurrentlyActive ? "activated" : "deactivated"}.`, "success");
      if (refetch) refetch();
    } else {
      await Swal.fire("Error!", "Could not update policy status.", "error");
    }
  };

  const actions = {
    entity: "Device Lock Policies",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add Policy",
      Show_Button: true,
      permission: "CreatePermission",
    },
    toggleActive: {
      key: "TOGGLE_ACTIVE",
      button_name: (row) => (row?.IsActive ? "Deactivate" : "Activate"),
      Show_Button: true,
      permission: "EditPermission",
      onClick: (row, refetch) => handleToggleActive(row, refetch),
    },
    dataObject: {
      ignoreFields: ["CreatedAt", "ShowType", "AllowIncomingList", "AllowAppList"],
      objectName: "allDeviceLockPolicies",
      inputObjectName: "param",
      parameters: {},
    },
    isSubRight: true,
    showStatus: true,
    showMore: {
      search: false,
      min: 0,
      max: 0,
    },
  };

  return (
    <Box m="20px">
      <Joyride
        steps={policyTourSteps}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        styles={{
          options: {
            primaryColor: "#1976d2",
            zIndex: 10000,
          },
        }}
      />
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
          Start Page Tour
        </Button>
      </Box>
      <DynamicTableForJson
        title="Device Lock Policies"
        subtitle="Automated Remind, Warning, and Lock Trigger Policies"
        FormComponent={Form}
        actions={actions}
        base_url={base_url}
        tourSteps={policyTourSteps}
      />
    </Box>
  );
};

export default DeviceLockPoliciesTable;
